import { isTestnet } from '../constants/envs';


export const REMOTE_JSON_PATH = `https://${isTestnet ? 'playtest' : 'play'}.crypto-shots.com/json`;

export const TOURNAMENTS_CONFIG_FILENAME = 'tournaments.json';

